import RefundVoucher from "../../components/Voucher/RefundVoucher";

const RefundVoucherDetailPage = () => {
  return (
    <div>
      <RefundVoucher />
    </div>
  );
};

export default RefundVoucherDetailPage;
